import { BeautySupplementCategory } from "./v1";

export const beautySupplementCategoryOptions = Object.entries(BeautySupplementCategory)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
